import React, { useState } from "react"
import Disqus from "disqus-react"

import { useSiteMetadata } from "../hooks/siteMetadata"

import styles from "../scss/components/Discussion.module.scss"

const Discussion = ({ post }) => {
  const [ open, setOpen ] = useState(false)
  const { siteUrl, disqus: { shortname } } = useSiteMetadata()

  const disqusConfig = {
    url: siteUrl,
    identifier: post.id,
    title: post.frontmatter.title,
  }

  return (
    <div>
      <div className={styles.wrapper}>
        <h4>Comments</h4>

        {!open && (
          <button className={styles.button} onClick={() => setOpen(true)}>
            Load comments...
          </button>
        )}

        {open && (
          <Disqus.DiscussionEmbed shortname={shortname} config={disqusConfig} />
        )}
      </div>
    </div>
  )
}

export default Discussion
